<template>
  <div class="headerStyle">
    github profile viewer
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
.headerStyle {
  display: flex;
  background-color: blue;
  justify-content: center;
  font-size: 100px;
}
</style>
